import { fetchWithCache } from './fetchWithCache';

const _inflight = {};

// Returns parsed JSON. Caches in localStorage + deduplicates concurrent requests.
// opts are passed through to fetchWithCache (e.g. `transform`).
export async function cachedFetch(url, ttlMs = 60000, opts = {}) {
  if (_inflight[url]) return _inflight[url];
  const p = fetchWithCache(url, { ...opts, cacheDuration: ttlMs })
    .finally(() => { delete _inflight[url]; });
  _inflight[url] = p;
  return p;
}
